import { mainApi } from "services/main";
import {
  SearchDocumentRequest,
  SearchDocumentResponse,
  GetDocumentUniqueValuesRequest,
  GetDocumentUniqueValuesResponse,
  RegisterDocumentsNewInput,
  RegisterDocumentsNewOutput,
  UpdateDocumentsNewInput,
  UpdateDocumentsNewOutput,
  DeleteDocumentsNewInput,
  DeleteDocumentsNewOutput,
  GetDocumentNewInput,
  GetDocumentNewOutput,
  CreateTeamFilesImportInput,
  CreateTeamFilesImportOutput,
  CreateTeamFilesExportInput,
  CreateTeamFilesExportOutput,
} from "./definitions";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    searchDocuments: builder.query<
      SearchDocumentResponse,
      SearchDocumentRequest
    >({
      query: (params) => ({
        url: "/documents-new/search",
        method: "POST",
        body: params,
      }),
      providesTags: ["Documents"],
    }),
    getDocumentUniqueValues: builder.query<
      GetDocumentUniqueValuesResponse,
      GetDocumentUniqueValuesRequest
    >({
      query: (params) => ({
        url: "/documents-new/unique-values",
        method: "POST",
        body: params,
      }),
    }),
    registerDocumentsNew: builder.mutation<
      RegisterDocumentsNewOutput,
      RegisterDocumentsNewInput
    >({
      query: (params) => ({
        url: "/documents-new/register",
        method: "POST",
        body: params,
      }),
      invalidatesTags: ["Documents"],
    }),
    updateDocumentsNew: builder.mutation<
      UpdateDocumentsNewOutput,
      UpdateDocumentsNewInput
    >({
      query: (params) => ({
        url: "/documents-new/update",
        method: "POST",
        body: params,
      }),
      invalidatesTags: ["Documents"],
    }),
    deleteDocumentsNew: builder.mutation<
      DeleteDocumentsNewOutput,
      DeleteDocumentsNewInput
    >({
      query: (params) => ({
        url: "/documents-new/delete",
        method: "POST",
        body: params,
      }),
      invalidatesTags: ["Documents"],
    }),
    getDocumentNew: builder.query<GetDocumentNewOutput, GetDocumentNewInput>({
      query: (params) => ({
        url: `/documents-new/document/${params.documentId}`,
        method: "GET",
      }),
      providesTags: ["Documents"],
    }),
    createTeamFilesImport: builder.mutation<
      CreateTeamFilesImportOutput,
      CreateTeamFilesImportInput
    >({
      query: (params) => ({
        url: "/team-files/import",
        method: "POST",
        body: params,
      }),
    }),
    createTeamFilesExport: builder.mutation<
      CreateTeamFilesExportOutput,
      CreateTeamFilesExportInput
    >({
      query: (params) => ({
        url: "/team-files/export",
        method: "POST",
        body: params,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useSearchDocumentsQuery,
  useLazySearchDocumentsQuery,
  useGetDocumentUniqueValuesQuery,
  useRegisterDocumentsNewMutation,
  useUpdateDocumentsNewMutation,
  useDeleteDocumentsNewMutation,
  useGetDocumentNewQuery,
  useLazyGetDocumentNewQuery,
  useCreateTeamFilesImportMutation,
  useCreateTeamFilesExportMutation,
} = extendedApi;
